var map = {
	"./arrange.svg": 91828,
	"./arrow-go-to-top.svg": 16722,
	"./arrow-left-white.svg": 17798,
	"./arrow-left.svg": 54720,
	"./arrow-right-white.svg": 20903,
	"./arrow-right.svg": 33321,
	"./calendar.svg": 33734,
	"./chat-bubbles.svg": 81706,
	"./chat-mask.svg": 36143,
	"./chat-search-btn.svg": 14081,
	"./checkmark-primary-salmon.svg": 99962,
	"./checkmark.svg": 81880,
	"./chevron-down-secondary.svg": 54810,
	"./chevron-down.svg": 87164,
	"./chevron-left-secondary.svg": 6224,
	"./chevron-left.svg": 28305,
	"./chevron-right-secondary.svg": 71253,
	"./chevron-right.svg": 99193,
	"./close-rounded.svg": 88809,
	"./close.svg": 15103,
	"./comment.svg": 3613,
	"./comparison-arrow.svg": 96158,
	"./contact.svg": 29360,
	"./curve-alternative.svg": 80538,
	"./curve-footer.svg": 56641,
	"./curve-header-bottom.svg": 79824,
	"./curve-header.svg": 25750,
	"./curve-low-left-white.svg": 36840,
	"./curve-low-left.svg": 55735,
	"./curve-low-right.svg": 91914,
	"./curve.svg": 57974,
	"./email-edit.svg": 22096,
	"./envelope-open.svg": 8684,
	"./external-link-pink.svg": 59380,
	"./external-link.svg": 46482,
	"./facebook.svg": 20196,
	"./file.svg": 97097,
	"./icomoon-home.svg": 43447,
	"./instagram.svg": 9633,
	"./kids-foundation-logo-color.svg": 51354,
	"./kids-foundation-logo-white.svg": 31215,
	"./know.svg": 61849,
	"./link.svg": 29473,
	"./linkedin.svg": 60463,
	"./location-service.svg": 20873,
	"./location.svg": 35679,
	"./marker.svg": 74218,
	"./partou-smallsteps-logo.svg": 56200,
	"./phone-outline.svg": 35996,
	"./phone.svg": 39177,
	"./pinterest.svg": 39629,
	"./question.svg": 37362,
	"./quote-image-placeholder.svg": 79683,
	"./search.svg": 41868,
	"./shield-cutout.svg": 47809,
	"./shield-full.svg": 59679,
	"./shield-mask-full-rotated.svg": 17263,
	"./shield-mask-full.svg": 20763,
	"./shield-small.svg": 55182,
	"./shield-white.svg": 42360,
	"./shield-with-shadow.svg": 26160,
	"./shield.svg": 90215,
	"./smallsteps-partou-logo.svg": 45013,
	"./tiktok.svg": 10087,
	"./touch.svg": 33521,
	"./twitter.svg": 18402,
	"./video-audio.svg": 49892,
	"./video-mute.svg": 65740,
	"./video-pause.svg": 61633,
	"./video-play-button-hover.svg": 9108,
	"./video-play-button.svg": 44488,
	"./welcome-background-shield.svg": 15133,
	"./whatsapp.svg": 97193,
	"./youtube.svg": 51352
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 92692;